import cloneDeep from 'lodash/cloneDeep';
import widgetHelper from '../widget-utilities/widget-helper';
import d3Utils from '../../../utils/d3Utils';
import chartUtils from '../../../utils/chart-utils';

/* Config builder for Web View widget */
var webViewConfigBuilder = function webViewConfigBuilder() {
    var modifyChartData = function modifyChartData(data) {
        var dataProperties = ['Data'];
        dataProperties.forEach(function (dataProperty) {
            data[dataProperty] = Object.prototype.hasOwnProperty.call(data, dataProperty) ? chartUtils.tryJsonParse(data[dataProperty]) : null;
        });
        return data;
    };

    // Add custom properties to original config
    var modifyWebViewConfigProperties = function modifyWebViewConfigProperties(config) {
        var Data = config.Data;

        // Initialize properties with empty strings if properties are null

        config.Data = modifyChartData(Data);
        return config;
    };

    // Remove unwanted properties, add custom properties and initialize null/undefined values
    var configBuilder = function configBuilder(config) {

        // Add common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        // Add Web View widget specific config properties
        config = modifyWebViewConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};

export default webViewConfigBuilder();